define('AwaLabs.CMSFullBanner.Main', [
    'AwaLabs.CMSFullBanner.CCTFullBanner'
], function AwaLabsCMSFullBannerMain(
    AwaLabsCMSFullBannerCCTFullBanner
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            AwaLabsCMSFullBannerCCTFullBanner.mountToApp(application);
        }
    };
});
